import { Button, Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled(Typography)`
  color: #000000;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
`;

export const Subtitle = styled(Typography)`
  color: #000000;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;
export const CustomizedButton = styled(Button)`
  background-color: #ffbc00;
  box-shadow: none;
  border-radius: 4px;
  color: #000000;
  height: 48px;
  padding: 8px 16px 8px 16px;

  &:hover {
    background-color: #ffbc00;
    box-shadow: none;
    color: #fff;
  }
`;
